// app/javascript/controllers/mask_controller.js
// Usage: <%= f.text_field :property_apn, data: { controller: "mask", mask_pattern_value: "apn", action: "input->mask#applyMask" } %>
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { pattern: String };

  connect() {
    this.patterns = {
      phone: "000-000-0000",
      apn: "000-000-000-000",
      account: "00-00",
      zip: "00000",
    };

    // Apply initial mask if field has value
    if (this.element.value) {
      this.applyMask();
    }
  }

  applyMask() {
    const pattern = this.patterns[this.patternValue];
    if (!pattern) return;

    const cursorPos = this.element.selectionStart;
    const oldValue = this.element.value;
    const cleaned = oldValue.replace(/\D/g, "");

    // Format value according to pattern
    let formatted = "";
    let digitIndex = 0;

    for (let i = 0; i < pattern.length && digitIndex < cleaned.length; i++) {
      if (pattern[i] === "0") {
        formatted += cleaned[digitIndex++];
      } else {
        formatted += pattern[i];
      }
    }

    // Update value
    this.element.value = formatted;

    // Calculate cursor position based on how many digits were before cursor in old value
    const digitsBeforeCursor = oldValue
      .slice(0, cursorPos)
      .replace(/\D/g, "").length;
    let newPos = 0;
    let digitCount = 0;

    for (let i = 0; i < formatted.length; i++) {
      if (/\d/.test(formatted[i])) {
        digitCount++;
        if (digitCount >= digitsBeforeCursor) {
          newPos = i + 1;
          break;
        }
      }
    }

    // If we haven't found the position yet, put cursor at the end
    if (newPos === 0) newPos = formatted.length;

    this.element.setSelectionRange(newPos, newPos);
  }
}
